export const navbarListItems = [
	{ _id: 1, link: "", name: "Home" },
	{ _id: 2, link: "about", name: "About Us" },
	{ _id: 3, link: "blog", name: "Blog" },
	{ _id: 4, link: "services", name: "Services" },
];
